<script lang="ts" setup>
import InvestorHero from '@/domains/investor/components/Hero/Hero.vue'
import FileList from '@/domains/investor/components/FileList/FileList.vue'

definePageMeta({
  layout: 'investor',
})

const { t, locale } = useI18n()

useHead(() => ({
  title: t('pageTitles.investorEsgNonfinancialReports.title'),
  meta: [
    {
      name: 'description',
      content: t('pageTitles.investorEsgNonfinancialReports.meta'),
    },
  ],
  link: [
    {
      rel: 'canonical',
      href: t(`pageTitles.investorEsgNonfinancialReports.canonical.${locale.value}`),
    },
    {
      rel: 'alternate',
      hreflang: 'pl',
      href: t('pageTitles.investorEsgNonfinancialReports.canonical.pl'),
    },
    {
      rel: 'alternate',
      hreflang: 'en',
      href: t('pageTitles.investorEsgNonfinancialReports.canonical.en'),
    },
    {
      rel: 'alternate',
      hreflang: 'x-default',
      href: t('pageTitles.investorEsgNonfinancialReports.canonical.pl'),
    },
  ],
}))

</script>

<template>
  <div>
    <InvestorHero
      :title="$t('investor.esgNonfinancialReports.hero.title')"
      :lead="$t('investor.esgNonfinancialReports.hero.lead')"
      image="/images/investor/hero/esg-nonfinancial-reports.png"
    />

    <UiSection
      :id="$t('investor.esgNonfinancialReports.sectionId')"
      class="esg-presentations__section"
      color="white"
    >
      <FileList
        request-id="investor-raporty-esg-niefinansowe-dokumenty"
        :show-title="true"
        variant="list"
        :file-item-link-options="{label:t('investor.files.seeFile')}"
      />
      
    </UiSection>
  </div>
</template>
